import { WelcomeAttaches } from 'reactApp/components/WelcomeAttaches/WelcomeAttaches';
import { WelcomeDialogNew } from 'reactApp/ui/WelcomeDialogNew/WelcomeDialogNew';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';

import WelcomeDialogConnected from './WelcomeDialog';

export const renderWelcomeDialogHelper = renderModalDialog(WelcomeDialogConnected, 'WelcomeDialog');
export const renderWelcomeAttachesDialogHelper = renderModalDialog(WelcomeAttaches, 'WelcomeAttaches');
// tempexp_14505-next-line
export const renderWelcomeDialogNewHelper = renderModalDialog(WelcomeDialogNew, 'WelcomeDialogNew');

export default {
    renderWelcomeDialogHelper,
    renderWelcomeAttachesDialogHelper,
    // tempexp_14505-next-line
    renderWelcomeDialogNewHelper,
};
